<template>
  <div class="AcRemoteWidget lxn-w100 lxn-h100 lxn-pos-rel" :class="disabledClass">
    <AcRemoteControllerSlim :nodeUUID="nodeUUID" :outputIndex="outputIndex" :sendCommand="sendCommand" :showDummy="showDummy" />
  </div>
</template>

<script>
import AcRemoteControllerSlim from '@/components/Home/Devices/AcRemoteControllerSlim.vue'

export default {
  name: 'AcRemoteWidget',
  props: {
    index: Number
  },
  components: {
    AcRemoteControllerSlim
  },
  data: function () {
    return {
    }
  },
  mounted: function () {
  },
  computed: {
    showDummy: function () {
      return (this.index == -1);
    },
    sendCommand: function () {
      return (this.index != -1);
    },
    nodeUUID: function () {
      if(this.index != -1){
        return this.node.uuid;
      }else{
        return null;
      }
    },
    outputIndex: function () {
      if(this.index != -1){
        return this.widget.settings.outputIndex;
      }else{
        return null;
      }
    },
    widget: function () {
      if(this.index != -1){
        return this.$store.state.widgets[this.index];
      }else{
        return null;
      }
    },
    widgetColor: function () {
      if(this.index != -1){
        return this.$store.state.themeMainColors[this.widget.color];
      }else{
        return this.$store.state.themeMainColors[4];
      }
    },
    node: function () {
      if(this.index != -1){
        return this.$store.getters.getNodeByUUID(this.widget.nodeUUIDs[0]);
      }else{
        return null;
      }
    },
    hub: function () {
      if(this.index != -1){
        return this.$store.getters.getHubByUUID(this.widget.hubUUID);
      }else{
        return null;
      }
    },
    isHubOffline: function () {
      var isHubOffline = false;
      if(this.index != -1){
        var hub = this.$store.getters.getHubByUUID(this.widget.hubUUID);
        if(hub.connectionStatus.local != 2 && hub.connectionStatus.online != 2){
          isHubOffline = true;
        }
      }
      return isHubOffline;
    },
    disabledClass: function () {
      if(this.index != -1){
        if(this.isHubOffline){
          return "disabled";
        }else{
          return "";
        }
      }else{
        return "";
      }
    },
  },
  methods: {
  },
}
</script>

<style>
@media all {
  .AcRemoteWidget {
    height: 180px;
  }
}
</style>
